import { render, staticRenderFns } from "./XMLModal.vue?vue&type=template&id=07679e38&scoped=true"
import script from "./XMLModal.vue?vue&type=script&lang=js"
export * from "./XMLModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07679e38",
  null
  
)

export default component.exports